import { render, staticRenderFns } from "./Pageheader.vue?vue&type=template&id=15dfb5f8&scoped=true&"
import script from "./Pageheader.vue?vue&type=script&lang=ts&"
export * from "./Pageheader.vue?vue&type=script&lang=ts&"
import style0 from "./Pageheader.vue?vue&type=style&index=0&id=15dfb5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dfb5f8",
  null
  
)

export default component.exports